import { defineComponent as h, ref as v, watch as y, computed as b, useCssVars as $ } from "vue";
import { E as l, a as k } from "./const-CZJ2cQu8.js";
import { n as w } from "./_plugin-vue2_normalizer-WQT2Fc8L.js";
import './assets/DIcon-CV2BSPtj.css';const n = /* @__PURE__ */ Object.assign({
  "./img/actions/chain.svg": () => import("./assets/ccd30a32d34f7500.svg").then((t) => t.default),
  "./img/actions/copy.svg": () => import("./assets/566d6f95912ac889.svg").then((t) => t.default),
  "./img/actions/copy_bold.svg": () => import("./assets/77c83f0f79310cdf.svg").then((t) => t.default),
  "./img/actions/download.svg": () => import("./assets/6da8ae91dc13b181.svg").then((t) => t.default),
  "./img/actions/download_bold.svg": () => import("./assets/4453a7c606a8d9dc.svg").then((t) => t.default),
  "./img/actions/share.svg": () => import("./assets/2dfc88234705294d.svg").then((t) => t.default),
  "./img/actions/share_bold.svg": () => import("./assets/fc25959f3534862c.svg").then((t) => t.default),
  "./img/actions/upload.svg": () => import("./assets/c481938b94f7ea59.svg").then((t) => t.default),
  "./img/arrows/arrow-down.svg": () => import("./assets/cbd57a570b9a5116.svg").then((t) => t.default),
  "./img/arrows/arrow-down_bold.svg": () => import("./assets/d2e96e36cc1b61ca.svg").then((t) => t.default),
  "./img/arrows/arrow-left.svg": () => import("./assets/32a118afad3b18ff.svg").then((t) => t.default),
  "./img/arrows/arrow-left_bold.svg": () => import("./assets/2fbfd10a95160c84.svg").then((t) => t.default),
  "./img/arrows/arrow-right.svg": () => import("./assets/a63ebf1871ac348b.svg").then((t) => t.default),
  "./img/arrows/arrow-right_bold.svg": () => import("./assets/fa1478bcb76efe12.svg").then((t) => t.default),
  "./img/check/check-circle.svg": () => import("./assets/ec52dcecb90b9e91.svg").then((t) => t.default),
  "./img/check/check-circle_bold.svg": () => import("./assets/a87420ccd46f0436.svg").then((t) => t.default),
  "./img/check/check.svg": () => import("./assets/9b597820632e84bf.svg").then((t) => t.default),
  "./img/check/close.svg": () => import("./assets/95e437cce3c60290.svg").then((t) => t.default),
  "./img/check/close_bold.svg": () => import("./assets/e42aeabd153ea5fd.svg").then((t) => t.default),
  "./img/check/minus.svg": () => import("./assets/68116725071442f4.svg").then((t) => t.default),
  "./img/check/plus.svg": () => import("./assets/96e228c18cb4a454.svg").then((t) => t.default),
  "./img/check/plus_bold.svg": () => import("./assets/22e23c692b05e302.svg").then((t) => t.default),
  "./img/currency/cny.svg": () => import("./assets/998b8c478945058f.svg").then((t) => t.default),
  "./img/currency/eur.svg": () => import("./assets/908d98ace238ae7c.svg").then((t) => t.default),
  "./img/currency/rub.svg": () => import("./assets/e9e5741c36f3a907.svg").then((t) => t.default),
  "./img/currency/usd.svg": () => import("./assets/4f7d1081ae0e4295.svg").then((t) => t.default),
  "./img/device/clock.svg": () => import("./assets/4b7aee01991f209a.svg").then((t) => t.default),
  "./img/device/clock_bold.svg": () => import("./assets/156432c5aac38b4b.svg").then((t) => t.default),
  "./img/device/qr.svg": () => import("./assets/b53dc3c535b1bc97.svg").then((t) => t.default),
  "./img/device/qr_bold.svg": () => import("./assets/7568861f0525f77d.svg").then((t) => t.default),
  "./img/docs/document_16.svg": () => import("./assets/f604b46b06b1ac9d.svg").then((t) => t.default),
  "./img/docs/document_24.svg": () => import("./assets/7879dd1c08ea4340.svg").then((t) => t.default),
  "./img/docs/signed-doc_16.svg": () => import("./assets/486d5c2d82eb7d22.svg").then((t) => t.default),
  "./img/docs/signed-doc_24.svg": () => import("./assets/2cdefbdfe452f58c.svg").then((t) => t.default),
  "./img/docs/unsigned-doc_16.svg": () => import("./assets/53707413d214c25a.svg").then((t) => t.default),
  "./img/docs/unsigned-doc_24.svg": () => import("./assets/3c6437c7b0fea186.svg").then((t) => t.default),
  "./img/loaders/default.svg": () => import("./assets/cb97b9b0e5c27be7.svg").then((t) => t.default),
  "./img/map/compass.svg": () => import("./assets/32169807c6ac78be.svg").then((t) => t.default),
  "./img/map/geo.svg": () => import("./assets/81e3970ae8fc49c5.svg").then((t) => t.default),
  "./img/map/geo_bold.svg": () => import("./assets/8f8962f948cf09a9.svg").then((t) => t.default),
  "./img/map/map-pin.svg": () => import("./assets/00784b7ab693f46b.svg").then((t) => t.default),
  "./img/map/map.svg": () => import("./assets/667f597b31b4c460.svg").then((t) => t.default),
  "./img/map/map_bold.svg": () => import("./assets/2ae8abb7606a9794.svg").then((t) => t.default),
  "./img/map/navi.svg": () => import("./assets/bc60a8187d21e9ae.svg").then((t) => t.default),
  "./img/map/way.svg": () => import("./assets/62e4bf162c632bf7.svg").then((t) => t.default),
  "./img/map/web.svg": () => import("./assets/6558b914ef5f3df8.svg").then((t) => t.default),
  "./img/notify/alert.svg": () => import("./assets/57b6e810364de30a.svg").then((t) => t.default),
  "./img/notify/alert_bold.svg": () => import("./assets/63b5e2675f8d7f78.svg").then((t) => t.default),
  "./img/notify/information.svg": () => import("./assets/08f44111e5214f7b.svg").then((t) => t.default),
  "./img/notify/information_bold.svg": () => import("./assets/183c348e7293a1ad.svg").then((t) => t.default),
  "./img/notify/question.svg": () => import("./assets/f920e65eac149c83.svg").then((t) => t.default),
  "./img/notify/question_bold.svg": () => import("./assets/95da18e2a2b85b87.svg").then((t) => t.default),
  "./img/safety/safety.svg": () => import("./assets/4d1ecb3c436cc992.svg").then((t) => t.default),
  "./img/safety/safety_bold.svg": () => import("./assets/95a72b8da2e005bb.svg").then((t) => t.default),
  "./img/settings/search.svg": () => import("./assets/072c74be32735692.svg").then((t) => t.default),
  "./img/settings/search_bold.svg": () => import("./assets/bd0c39204ec20125.svg").then((t) => t.default),
  "./img/social/metro.svg": () => import("./assets/3684c27346697605.svg").then((t) => t.default),
  "./img/text-editing/circle-draft.svg": () => import("./assets/5305098cc4f1a947.svg").then((t) => t.default),
  "./img/text-editing/close-eye.svg": () => import("./assets/e6f592f87573363f.svg").then((t) => t.default),
  "./img/text-editing/close-eye_bold.svg": () => import("./assets/1ca88e0e09f2c637.svg").then((t) => t.default),
  "./img/text-editing/open-eye.svg": () => import("./assets/c0f38260ff949058.svg").then((t) => t.default),
  "./img/text-editing/open-eye_bold.svg": () => import("./assets/16e6bade67c4ff28.svg").then((t) => t.default),
  "./img/text-editing/remove-from-home.svg": () => import("./assets/08bc353dc44ea90d.svg").then((t) => t.default),
  "./img/text-editing/rename.svg": () => import("./assets/83da321d8b69c230.svg").then((t) => t.default),
  "./img/text-editing/rename_bold.svg": () => import("./assets/b047cae427384fb6.svg").then((t) => t.default),
  "./img/text-editing/return-to-home.svg": () => import("./assets/33c6a3173a57a7e1.svg").then((t) => t.default)
}), r = h({
  props: {
    name: { type: String, required: !0 },
    /** sizes like ESize.S_24_16 is 24 for desktop 16 for mobile  */
    size: { type: String, default: () => l.S_24 },
    color: { type: String, default: () => k.PRIMARY },
    colorCustom: { type: String, default: void 0 },
    block: { type: Boolean },
    bold: { type: Boolean }
  },
  emits: ["click"],
  setup(t) {
    const e = v("");
    y([() => t.name, () => t.size, () => t.bold], ([m, g, f]) => {
      if (!m || !g) return;
      const d = f ? "_bold" : "", a = `_${g}`;
      try {
        const [i, o] = m.toString().split("/");
        (n[`./img/${i}/${o}${d}${a}.svg`] ?? n[`./img/${i}/${o}${a}.svg`] ?? n[`./img/${i}/${o}${d}.svg`] ?? n[`./img/${i}/${o}.svg`])().then((_) => {
          e.value = `url("${_}")`;
        });
      } catch {
        return;
      }
    }, { immediate: !0 });
    const s = b(() => t.colorCustom ?? `var(--d-color-${t.color})`);
    return {
      icon: e,
      ESize: l,
      iconColor: s
    };
  }
}), c = () => {
  $((t, e) => ({
    "7642fabb": t.icon,
    "0187c168": t.iconColor
  }));
}, u = r.setup;
r.setup = u ? (t, e) => (c(), u(t, e)) : c;
const z = {
  "d-icon": "_d-icon_1s9qg_7",
  "d-icon_size-16": "_d-icon_size-16_1s9qg_20",
  "d-icon_size-24": "_d-icon_size-24_1s9qg_23",
  "d-icon_size-24-16": "_d-icon_size-24-16_1s9qg_26",
  "d-icon_block": "_d-icon_block_1s9qg_34"
};
var S = function() {
  var e = this, s = e._self._c;
  return e._self._setupProxy, s("i", { class: [
    e.$style["d-icon"],
    e.block && e.$style["d-icon_block"],
    {
      [e.$style["d-icon_size-24"]]: e.size === e.ESize.S_24,
      [e.$style["d-icon_size-16"]]: e.size === e.ESize.S_16,
      [e.$style["d-icon_size-24-16"]]: e.size === e.ESize.S_24_16
    }
  ], on: { click: function(m) {
    return e.$emit("click");
  } } });
}, x = [];
const p = {
  $style: z
};
function q(t) {
  for (var e in p)
    this[e] = p[e];
}
var C = /* @__PURE__ */ w(
  r,
  S,
  x,
  !1,
  q
);
const B = C.exports;
export {
  B as D
};
